(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 2890:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(1342);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs
var jsx_runtime = __webpack_require__(7320);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 28 modules
var esm = __webpack_require__(7985);
;// CONCATENATED MODULE: ./data/posts.json
var posts_namespaceObject = JSON.parse('{"total":{"es":2,"en":2},"latest":[{"slug":"2021","lang":"es","content":{"title":"2021 diario de reflexiones: Un año de aprendizajes y decisiones","summary":"2020 versión 1 o 2021 fue el año en el que el mundo parecía volver a la normalidad tras los cierres y la pandemia mundial, pero la realidad fue todo lo contrario. Para mí un año de decisiones y aprendizajes saliendo de la zona de confort.","tags":["career","reflections"],"ttr":"7","slugs":{"en":2021,"es":2021},"publishedAt":"2022-01-10","image":"https://res.cloudinary.com/iolivares-photos/image/upload/w_2000,ar_16:9,c_fill,g_auto,e_sharpen/v1641174915/io-dot-com/posts/2021/1fgj6dfj33nd55i17c9c_iax1wg.jpg"}},{"slug":"2021","lang":"en","content":{"title":"2021 reflections journal: A year of learnings and decisions","summary":"2020 version 1 or 2021 was the year where the world looked to return to normal from lockdowns and the global pandemic, but the reality was anything but. For me a year of decisions and learnings getting out of comfort zone.","tags":["career","reflections"],"ttr":"7","slugs":{"en":2021,"es":2021},"publishedAt":"2022-01-10","image":"https://res.cloudinary.com/iolivares-photos/image/upload/w_2000,ar_16:9,c_fill,g_auto,e_sharpen/v1641174915/io-dot-com/posts/2021/1fgj6dfj33nd55i17c9c_iax1wg.jpg"}}],"all":[{"slug":"hola-mundo","lang":"es","content":{"title":"Hola Mundo","summary":"Bienvenid@s (de nuevo) a mi nuevo blog. Quizá, pero esta más en serio, comenzaré a publicar nuevos artículos cada mes o semanalmente (dependerá del ánimo, tiempos, etc).","tags":["launches","new-release"],"ttr":"1","slugs":{"en":"hello-world","es":"hola-mundo"},"publishedAt":"2021-12-31","image":"https://res.cloudinary.com/iolivares-photos/image/upload/w_2000,ar_16:9,c_fill,g_auto,e_sharpen/v1641175008/io-dot-com/posts/photo-1579969756514-9f206e7c34a2_kz8vqh.jpg"}},{"slug":"hello-world","lang":"en","content":{"title":"Hello World","summary":"Welcome (again) to my new blog. Maybe, but this time surelly, I will start to publish new posts every month or week (depends of the mood, times, etc).","tags":["launches","new-release"],"ttr":"1","slugs":{"en":"hello-world","es":"hola-mundo"},"publishedAt":"2021-12-31","image":"https://res.cloudinary.com/iolivares-photos/image/upload/w_2000,ar_16:9,c_fill,g_auto,e_sharpen/v1641175008/io-dot-com/posts/photo-1579969756514-9f206e7c34a2_kz8vqh.jpg"}}]}');
// EXTERNAL MODULE: ./layouts/ContentLayout.js
var ContentLayout = __webpack_require__(7830);
// EXTERNAL MODULE: ./components/LatestItem.js
var LatestItem = __webpack_require__(8062);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(8420);
// EXTERNAL MODULE: ./lib/dates.js
var dates = __webpack_require__(7426);
;// CONCATENATED MODULE: ./components/PostsList.js







function PostsList(param) {
    var posts = param.posts;
    var locale = (0,router.useRouter)().locale;
    var t = (0,esm/* useTranslation */.$G)('posts').t;
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("article", {
        className: "mt-6 mb-10 sm:mb-20",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "max-w-6xl mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("h2", {
                    className: "mb-8 title-font text-2xl lg:text-3xl xl:text-4xl font-bold tracking-tighter text-left text-gray-800 dark:text-gray-100",
                    children: [
                        "👨‍💻 ",
                        t('posts-all-title')
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "flex flex-wrap",
                    children: posts.length > 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                        className: "w-full list-none divide-y divide-gray-100 dark:divide-gray-600",
                        children: posts.map(function(post, index) {
                            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("li", {
                                className: "py-2",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_link["default"], {
                                    href: post.slug,
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("a", {
                                        className: "w-full py-2 px-4 flex justify-between items-center text-left rounded-md group md:hover:px-8 md:hover:bg-gray-100 md:dark:hover:bg-gray-800 motion-safe:transition-all motion-safe:duration-300",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                                className: "flex sm:items-center flex-col-reverse sm:flex-row",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                        className: "flex-[0_0_auto] pr-0 mt-2 sm:pr-12 sm:mt-0 text-xs font-semibold tracking-widest uppercase text-primary-500 dark:text-primary-300 group-hover:text-primary-400 group-hover:dark:text-primary-50",
                                                        children: (0,dates/* formatDate */.p6)((0,parseISO/* default */.Z)(post.content.publishedAt), locale)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                        className: "flex-[1] text-xs font-semibold tracking-widest uppercase text-primary-500 dark:text-primary-300 group-hover:text-primary-400 group-hover:dark:text-primary-50",
                                                        children: post.content.title
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                className: "flex flex-[0_0_auto] justify-end ml-8 w-8 text-primary-500 dark:text-primary-300 group-hover:text-primary-400 group-hover:dark:text-primary-50",
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    className: "h-8 w-8",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        strokeWidth: "2",
                                                        d: "M13 7l5 5m0 0l-5 5m5-5H6"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }, index);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "flex flex-col w-full mx-auto text-center pt-5 pb-6 px-5 xl:px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "text-sm font-mono text-gray-800 dark:text-gray-100 break-words",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                    children: [
                                        t('posts-no-more'),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "w-1 h-4 ml-2 inline-block bg-primary-800 dark:bg-gray-400 rounded-sm motion-safe:animate-ping motion-safe:duration-75",
                                            children: " "
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_link["default"], {
                                        href: "/talks",
                                        children: t('posts-no-more-cta')
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./pages/blog.js







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Blog = function(props) {
    var ref, ref1;
    var locale = (0,router.useRouter)().locale;
    var t = (0,esm/* useTranslation */.$G)('posts').t;
    var latestPost = posts_namespaceObject === null || posts_namespaceObject === void 0 ? void 0 : (ref = posts_namespaceObject.latest) === null || ref === void 0 ? void 0 : ref.filter(function(post) {
        return post.lang === locale;
    })[0];
    var allPosts = posts_namespaceObject === null || posts_namespaceObject === void 0 ? void 0 : (ref1 = posts_namespaceObject.all) === null || ref1 === void 0 ? void 0 : ref1.filter(function(post) {
        return post.lang === locale;
    });
    return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ContentLayout/* default */.Z, _objectSpread({}, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                dangerouslySetInnerHTML: {
                    __html: t('posts-single', {
                        interpolation: {
                            escapeValue: false
                        },
                        value: posts_namespaceObject === null || posts_namespaceObject === void 0 ? void 0 : posts_namespaceObject.total[locale]
                    })
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LatestItem/* default */.Z, {
                item: latestPost,
                dict: "posts"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PostsList, {
                posts: allPosts
            })
        ]
    })));
};
var __N_SSG = true;
/* harmony default export */ var blog = (Blog);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [22,477,276,888,179], function() { return __webpack_exec__(2890); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);